import type { RouteRecordRaw } from "vue-router";
import { Finanzmanager } from "@/application/router/types/types.ts";
import MainLayout from "@/application/layouts/MainLayout.vue";
import BankingPage from '@/banking/pages/BankingPage.vue';
import Regprotect from '@/banking/pages/Regprotect.vue';
import BankAccessManager from '@/banking/pages/BankAccessManager.vue';
import Account from '@/banking/pages/Account.vue';
import Transaction from '@/banking/pages/Transaction.vue';
import Depot from '@/banking/pages/Depot.vue';
import Investment from '@/banking/pages/Investment.vue';
import BudgetAnalysis from '@/banking/pages/BudgetAnalysis.vue';
import BudgetAnalysisCategory from '@/banking/pages/BudgetAnalysisCategory.vue';
import BudgetAnalysisCategoryTransactions from '@/banking/pages/BudgetAnalysisCategoryTransactions.vue';
import { useBaseDataStore } from '@/user/store/baseDataStore.ts';
import { NotificationVariant, useNotification } from '@demvsystems/design-components';

export const bankingRoutes: RouteRecordRaw[] = [
  {
    path: '/banking',
    component: MainLayout,
    meta: {
      title: 'Banking',
    },
    beforeEnter: () => {
      const baseDataStore = useBaseDataStore();

      if (baseDataStore.isMagicLogin || baseDataStore.isBroker) {
        useNotification().show('Sie haben keinen Zugriff auf diese Resource.', NotificationVariant.Error);

        return { name: baseDataStore.isMagicLogin ? Finanzmanager.CHECKUP : Finanzmanager.VERTRAEGE };
      }
    },
    children: [
      {
        path: '',
        name: Finanzmanager.BANKING,
        component: BankingPage,
        meta: {
          title: 'Banking',
        },
      },
      {
        path: 'bam',
        component: BankAccessManager,
        meta: {
          hideHeaderBackNav: true,
        }
      },
      {
        path: 'regprotect',
        component: Regprotect,
        props: (route) => ({
          sessionLink: route.query.sessionLink,
          redirect: route.query.redirect,
        }),
        meta: {
          hideHeaderBackNav: true,
        }
      },
      {
        path: ':bankAccessId/account/:bankAccountId',
        component: Account,
        props: true,
        meta: {
          hideHeaderBackNav: true,
        }
      },
      {
        path: ':bankAccessId/account/:bankAccountId/transaction/:transactionId',
        component: Transaction,
        props: true,
        meta: {
          hideHeaderBackNav: true,
        }
      },
      {
        path: ':bankAccessId/depot/:depotId',
        component: Depot,
        props: true,
        meta: {
          hideHeaderBackNav: true,
        }
      },
      {
        path: ':bankAccessId/depot/:depotId/investment/:investmentId',
        component: Investment,
        props: true,
        meta: {
          hideHeaderBackNav: true,
        }
      },
      {
        path: 'budget-analysis',
        component: BudgetAnalysis,
        meta: {
          hideHeaderBackNav: true,
        }
      },
      {
        path: 'budget-analysis/category/:category',
        component: BudgetAnalysisCategory,
        props: true,
        meta: {
          hideHeaderBackNav: true,
        }
      },
      {
        path: 'budget-analysis/category/:category/transactions',
        component: BudgetAnalysisCategoryTransactions,
        props: true,
        meta: {
          hideHeaderBackNav: true,
        }
      },
    ]
  },
]
